import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const AssocLogo = ({ size = "h-10 w-10" }) => {
  const { assoc } = useAuth();
  const [src, setSrc] = useState(null);

  useEffect(() => {
    let url;
    if (assoc?.has_logo) {
      api.get("/association/logo", { responseType: "blob" }).then((r) => {
        url = URL.createObjectURL(r.data);
        setSrc(url);
      }).catch(() => setSrc(null));
    } else setSrc(null);
    return () => url && URL.revokeObjectURL(url);
  }, [assoc?.has_logo, assoc?.id, assoc?.updated_at]);

  if (src) return <img data-testid="association-logo-img" src={src} alt={`Logo ${assoc?.name || ""}`} className={`${size} shrink-0 rounded-lg object-contain bg-white`} />;
  return (
    <div data-testid="association-logo-placeholder" className={`${size} shrink-0 rounded-lg bg-primary text-primary-foreground flex items-center justify-center font-heading font-extrabold`}>
      {(assoc?.name || "A").slice(0, 2)}
    </div>
  );
};
